import { MAX_PUBLISH_PAGE_FOR_FREE_PLAN, PAGE_TYPES, PLAN_NAMES } from '@/modules/common';
import type { State } from './state';

const getters = {
  shopifyDomain(state: State) {
    if (state.shopInfo) {
      return state.shopInfo?.shopifyDomain;
    }
    return false;
  },
  shopifyPlan(state: State) {
    if (state.shopInfo) {
      return state.shopInfo?.shopifyPlan;
    }
    return false;
  },
  getSourceModalType: (state: State) => state.getSourceModalType,
  pageId(state: State) {
    if (!state.pageInfo) return false;
    return state.pageInfo.page.id;
  },
  pageType(state: State) {
    if (!state.pageInfo) return false;
    return state.pageInfo.page.type;
  },
  pagePlan(state: State) {
    // follow GFrame/index.vue data-plan
    if (!state.pageInfo) return 'starter';
    return state.pageInfo.plan;
  },
  pageGID(state: State) {
    if (!state.pageInfo) return false;
    return state.pageInfo.page.g_id;
  },
  runningCampaignId(state: State) {
    return state.pageInfo?.runningCampaignId;
  },
  isRunningAbTest(state: State) {
    if (!state.pageInfo?.runningCampaignId) return false;
    return state.pageInfo?.runningCampaignId > 0;
  },
  pageInfoData: (state: State) => state.pageInfo?.page,
  userScope: (state: State) => {
    if (state.shopInfo?.userScope) {
      const userScopeString = state.shopInfo.userScope;
      return userScopeString.split(',').map((permission) => permission.replace('\n', '').trim());
    }

    return [];
  },
  gemMeterOBD(state: State) {
    return state.shopMeter.onboarding;
  },
  isLimitPublish(state: State) {
    return state.pageInfo ? state.pageInfo.isLimitPublish : false;
  },
  limitPublishPage(state: State) {
    const currentShopPlan = state.shopInfo?.plan;
    if (currentShopPlan === PLAN_NAMES.TRIAL_2022) {
      return MAX_PUBLISH_PAGE_FOR_FREE_PLAN;
    }

    const planLimitation = state.shopInfo?.planLimitation;
    const currentPlanLimitation =
      typeof planLimitation === 'object' && planLimitation.hasOwnProperty(currentShopPlan) && currentShopPlan
        ? planLimitation[currentShopPlan]
        : null;

    let limitPublishPage = 0;
    if (state.pageInfo?.page.type === PAGE_TYPES.PRODUCT_PAGE) {
      limitPublishPage = currentPlanLimitation ? currentPlanLimitation.pagePublish.nbOfPublishedProductPage : 0;
    } else if (state.pageInfo?.page.type === PAGE_TYPES.ARTICLE_PAGE) {
      limitPublishPage = currentPlanLimitation ? currentPlanLimitation.pagePublish.nbOfPublishedArticlePage : 0;
    }

    return limitPublishPage;
  },
  publishedPage(state: State) {
    const currentShopPlan = state.shopInfo?.plan;
    if (currentShopPlan === PLAN_NAMES.TRIAL_2022) {
      return state.shopInfo?.publishedPagesCount || 0;
    }

    let publishedPage = 0;
    if (state.pageInfo?.page.type === PAGE_TYPES.PRODUCT_PAGE) {
      publishedPage = state.shopInfo?.publishedProductPagesCount || 0;
    } else if (state.pageInfo?.page.type === PAGE_TYPES.ARTICLE_PAGE) {
      publishedPage = state.shopInfo?.publishedArticlePagesCount || 0;
    }

    return publishedPage;
  },
  productPageDefault(state: State) {
    return state.pageInfo?.page.type === PAGE_TYPES.PRODUCT_PAGE && state.pageInfo?.published;
  },
  gemSession(state: State) {
    const urlParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlParams.entries());

    const shopInfoGemSession = state.shopInfo?.gemSession || '';
    const localGemSession = localStorage.getItem(`__gemSession_${params.shop}`) || '';

    return shopInfoGemSession || localGemSession;
  },
  shopInfoV7(state: State) {
    return state.shopInfoV7;
  },
};

export default getters;
